import React, { useState, useEffect, useCallback } from 'react';
import { Select } from 'antd';
import { debounce } from 'lodash';
import { apiGetCategory } from '@services/ManageDevices/DeviceServices';

const { Option } = Select;

const BranchSelectMultiple = ({ value, onChange, onBranchChange, showTitle = true }) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState('');

  const fetchBranches = async (search = '') => {
    setLoading(true);
    try {
      const response = await apiGetCategory({
        keyword: search === '' ? undefined : search,
        type: 'CN'
      });
      setOptions(
        response.data?.data
          .map((item) => ({
            label: item.name,
            value: item.value
          }))
          .sort((a, b) => a?.label?.localeCompare(b?.label, 'vi', { sensitivity: 'base' }))
      );
    } catch (error) {
      console.error('Error fetching branch data:', error);
    } finally {
      setLoading(false);
    }
  };

  // Tạo debounced function với useCallback để tránh tạo lại function mỗi lần render
  const debouncedFetchBranches = useCallback(
    debounce((searchText) => {
      fetchBranches(searchText);
    }, 800),
    []
  );

  useEffect(() => {
    fetchBranches();
  }, []);

  const handleChange = (values) => {
    onChange(values);
    // Clear search text after selection
    if (searchText) {
      setSearchText('');
      fetchBranches();
    }
    // Notify parent component about branch change
    if (onBranchChange) {
      onBranchChange(values);
    }
  };

  const handleSearch = (searchValue) => {
    setSearchText(searchValue);
    if (searchValue === '') {
      // Nếu xóa hết keyword, gọi API ngay lập tức
      fetchBranches();
    } else {
      debouncedFetchBranches(searchValue);
    }
  };

  return (
    <div style={{ marginBottom: '16px' }}>
      {showTitle && (
        <label style={{ display: 'block', marginBottom: '4px', fontWeight: '500' }}>Nhà máy</label>
      )}
      <Select
        mode="multiple"
        value={value || []}
        onChange={handleChange}
        placeholder="Chọn Nhà máy"
        style={{ width: '100%', height: '36px' }}
        showSearch
        filterOption={false}
        onSearch={handleSearch}
        searchValue={searchText}
        loading={loading}
        maxTagCount="responsive"
        allowClear>
        {options.map((option) => (
          <Option key={option.value} value={option.value}>
            {option.label}
          </Option>
        ))}
      </Select>
    </div>
  );
};

export default BranchSelectMultiple;
